module.exports = __webpack_public_path__ + "img/icon_03.2557b39d.svg";